export default {"src":"/_next/static/media/business9.a1db209d.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};